var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Prop, Component, } from 'vue-property-decorator';
import * as uuid_v4 from 'uuid/v4';
var UploadButton = /** @class */ (function (_super) {
    __extends(UploadButton, _super);
    function UploadButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadButton.prototype.fileChanged = function (e) {
        if (e) {
            if (e.target.files) {
                if (!this.multiple && e.target.files[0]) {
                    this.$emit('changed', e.target.files[0]);
                }
                else if (this.multiple) {
                    this.$emit('changed', e.target.files);
                }
                else {
                    this.$emit('changed', null);
                }
            }
            else {
                this.$emit('changed', null);
            }
        }
    };
    Object.defineProperty(UploadButton.prototype, "id", {
        get: function () {
            return this.uniqueId ? uuid_v4() + "uploadFile" : 'uploadFile';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UploadButton.prototype, "classes", {
        get: function () {
            var classes = {
                'v-btn--block': this.block,
                'v-btn--flat': this.flat,
                'upload-btn-hover': this.hover,
                'v-btn--icon': this.icon,
                'v-btn--large': this.large,
                'v-btn--loading': this.loading,
                'v-btn--outline v-btn--depressed': this.outline,
                'v-btn--round': this.round,
                'v-btn--small': this.small,
                'v-btn--disabled': this.disabled,
                'v-btn--depressed': this.depressed,
            };
            if (this.flat) {
                this.color = '';
            }
            var classString = '';
            for (var key in classes) {
                if (classes[key]) {
                    classString += key + " ";
                }
            }
            return classString;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: false, default: '*' }),
        __metadata("design:type", String)
    ], UploadButton.prototype, "accept", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "block", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "depressed", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'primary' }),
        __metadata("design:type", String)
    ], UploadButton.prototype, "color", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "disabled", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "flat", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "hover", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "icon", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "large", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "loading", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "multiple", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'uploadFile' }),
        __metadata("design:type", String)
    ], UploadButton.prototype, "name", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "outline", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "round", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "small", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], UploadButton.prototype, "uniqueId", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'Upload' }),
        __metadata("design:type", String)
    ], UploadButton.prototype, "title", void 0);
    UploadButton = __decorate([
        Component
    ], UploadButton);
    return UploadButton;
}(Vue));
export default UploadButton;
